import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const ListStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idList"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idList"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"ListStatus","document":ListStatusDocument}} as const;
export type ListStatusQueryVariables = Types.Exact<{
  idList: Types.Scalars['ID']['input'];
}>;


export type ListStatusQuery = (
  { __typename: 'Query' }
  & { list?: Types.Maybe<(
    { __typename: 'List' }
    & Pick<Types.List, 'id' | 'status'>
  )> }
);

/**
 * __useListStatusQuery__
 *
 * To run a query within a React component, call `useListStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStatusQuery({
 *   variables: {
 *      idList: // value for 'idList'
 *   },
 * });
 */
export function useListStatusQuery(
  baseOptions: TrelloQueryHookOptions<
    ListStatusQuery,
    ListStatusQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: ListStatusDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<ListStatusQuery, ListStatusQueryVariables>(
    ListStatusDocument,
    options,
  );
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useListStatusLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    ListStatusQuery,
    ListStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListStatusQuery, ListStatusQueryVariables>(
    ListStatusDocument,
    options,
  );
}
export type ListStatusQueryHookResult = ReturnType<typeof useListStatusQuery>;
export type ListStatusLazyQueryHookResult = ReturnType<
  typeof useListStatusLazyQuery
>;
export type ListStatusQueryResult = Apollo.QueryResult<
  ListStatusQuery,
  ListStatusQueryVariables
>;
